export const dvh = (value: number) => {
  const supportDvh = CSS.supports('height', '100dvh');
  return `${value}${supportDvh ? 'dvh' : 'vh'}`;
};
